

import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { I18nextProvider } from "react-i18next";
import i18next from "./i18n";
import LoginForm from "./component/login";
import RegisterForm from "./component/register";
import Dashboard from "./component/dashboard";
import ContactForm from "./component/contact";
import Favourites from "./component/favourite";
import ProfileDetails from "./component/profileDetails";
import MobileVerification from "./component/mobile";
import Points from "./component/points";
import Sidebar from "./component/sidebar";
import ProfilePage from "./component/myProfile";
import LanguageSelect from "./component/languageSelect";
import MobileLogin from "./component/mobileLogin";
import MatchingProfiles from "./component/matchingProfiles";
import AboutUs from "./component/about";
import HowItWorks from "./component/itsWork";
import HowItWorking from "./component/frontHowIts";
import ChatWidget from "./component/chatbot";
import Settings from "./component/setting";
import ViewAllProfiles from "./component/viewAllprofiles";

const AppRoutes = () => {
  const location = useLocation();
  const hideChatWidgetPaths = ["/", "/login", "/howitswork", "/mobile", "/register"];

   const isMobileVerified = localStorage.getItem('mobileVerified') === 'true';
  const isLoggedIn = !!localStorage.getItem('authToken');

  return (
    <>
      <Routes>
        <Route path="/" element={<LanguageSelect />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/another" element={<MobileLogin />} />
        <Route path="/mobile" element={<MobileVerification />} />
        {/* <Route path="/register" element={<RegisterForm />} /> */}
        <Route 
          path="/register" 
          element={
            isMobileVerified ? (
              <RegisterForm />
            ) : (
              <Navigate to="/mobile" replace />
            )
          } 
        />
        <Route path="/setting" element={<Settings />} />
        <Route path="/sidebar" element={<Sidebar />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/view-all-profiles" element={<ViewAllProfiles />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/favourite" element={<Favourites />} />
        <Route path="/profile/:id" element={<ProfileDetails />} />
        <Route path="/matchingProfiles" element={<MatchingProfiles />} />
        <Route path="/points" element={<Points />} />
        <Route path="/my" element={<ProfilePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/how" element={<HowItWorks />} />
        <Route path="/howitswork" element={<HowItWorking />} />

        {/* Catch-all route */}
        <Route path="*" element={<Dashboard />} />
      </Routes>

      {!hideChatWidgetPaths.includes(location.pathname) && <ChatWidget />}
    </>
  );
};





const App = () => {
  return (
    <I18nextProvider i18n={i18next}>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <AppRoutes />
      </Router>
    </I18nextProvider>
  );
};


export default App;